module.exports = __webpack_public_path__ + "img/teacher.e748f759.svg";